// @ts-nocheck
import React, { useState, useEffect } from 'react';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from '../../../common/Button';
import DisabledReasonForm from '../components/DisabledReasonForm';
import { getDisableReasonById } from '../../../../api/keyCodeApi';
import { saveDisableReason } from '../../../../reducers/disableReasonReducer';
import { useAppDispatch } from '../../../../hooks';

function EditDisabledReason({ done, id, cancel }) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const [disabledReason, setDisabledReason] = useState({});

  useEffect(() => {
    if (id) {
      getDisableReasonById(id)
        .then((d) => {
          setDisabledReason(d);
        })
        .catch(() => {
          toast.error(t('Failed to load disabled reason'));
        });
    }
  }, [id, t]);

  const onSubmit = (data) => {
    dispatch(saveDisableReason({ ...disabledReason, ...data }))
      .unwrap()
      .then(() => {
        toast.success(t('Disabled reason saved'));
        done(disabledReason);
      });
  };

  return (
    <SlideoutLayout
      title={id ? t('Edit disabled reason') : t('Add disabled reason')}
      cancel={cancel}
      done={done}
      bar={
        <Button
          key="submit"
          text={t('Save')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          testId="save-disabled-reason-button"
        />
      }
    >
      <DisabledReasonForm
        disabledReason={disabledReason}
        register={register}
        errors={errors}
        control={control}
      />
    </SlideoutLayout>
  );
}



export default EditDisabledReason;
